import React from "react";
import { Document, Page, Text, View, StyleSheet,Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: "Helvetica",
    color: "#101828",
  },
  heading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#003149",
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  label: {
    color: "#344054",
    fontWeight: "bold",
  },
  value: {
    color: "#101828",
  },
});

const ExportDepartmentsPDF = ({ data,logo }) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
            {logo && (
          <Image
            src={logo}
            style={{ width: 120, alignSelf: "center", marginBottom: 10 }}
          />
        )}

        <Text style={styles.heading}>{t("departments.manageDepartments")}</Text>
        {data.map((item, index) => (
          <View key={index} style={styles.recordGroup}>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.id")}:</Text>
              <Text style={styles.value}>{item.id}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.departmentName")}:</Text>
              <Text style={styles.value}>{item.name}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.worker")}:</Text>
              <Text style={styles.value}>{item.workerCount}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.status")}:</Text>
              <Text style={styles.value}>{item.status}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("common.dateTime")}:</Text>
              <Text style={styles.value}>{item.date}</Text>
            </View>
          </View>
        ))}
      </Page>
    </Document>
  );
};

export default ExportDepartmentsPDF;